import { action } from 'typesafe-actions'
import { IFilter, ReportTypes } from './types'
// import { IAxiosResponse, IPaginator, ISearch } from '../root.types'
import { FollowUp } from '../../application/models/followUp/followUp'


export const loadFollowUpsReport = (followUps: FollowUp[]) =>
    action(
        ReportTypes.LOAD_FOLLOWUP_REPORT, { followUps }
    )

export const reportData = (data: any) =>
    action(
        ReportTypes.REPORT_DATA, { data }
    )

export const loadReportRequest = (filter: IFilter) => action(
    ReportTypes.LOAD_REPORT_REQUEST, { filter }
)
export const loadReportSuccess = (data: any) => action(
    ReportTypes.LOAD_REPORT_SUCCESS, { data }
)
export const loadReportFailure = () => action(ReportTypes.LOAD_REPORT_FAILURE)

